// Endereço da API. Localmente vem do .env (REACT_APP_API_URL=http://localhost:3001).
export const API_URL = process.env.REACT_APP_API_URL || 'https://api-chamada.vercel.app';
